<template>
  <div class="my-2">
    <div class="ChecklistShareTasksDialogRolePickerGroup-row py-2 px-4">
      <h4 class="text-truncated">
        {{ group.name }}
      </h4>
      <v-checkbox class="mt-0 pt-0 mx-auto"
                  density="compact"
                  hide-details
                  :model-value="areResponsiblesChecked"
                  readonly
                  @click="onResponsiblesClick"
      />
      <v-checkbox class="mt-0 pt-0 mx-auto"
                  density="compact"
                  hide-details
                  :model-value="areValidatorsChecked"
                  readonly
                  @click="onValidatorsClick"
      />
      <v-checkbox class="mt-0 pt-0 mx-auto"
                  density="compact"
                  hide-details
                  :model-value="areObserversChecked"
                  :disabled="isObserversCheckboxDisabled"
                  readonly
                  @click="!isObserversCheckboxDisabled && onObserversClick()"
      />
    </div>
    <ChecklistShareTasksDialogRolePickerGroupMember v-for="member in group.members"
                                                    :key="`member-${member.id}`"
                                                    :mnemo="mnemo"
                                                    :member="member"
                                                    :group="group"
                                                    :taskVisibleByAll="taskVisibleByAll"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import ChecklistShareTasksDialogRolePickerGroupMember from '@/project/checklist/dialogs/ChecklistShareTasksDialogRolePickerGroupMember.vue'
import {
  TOGGLE_SELECTED_RESPONSIBLES_GROUPS,
  TOGGLE_SELECTED_OBSERVERS_GROUPS,
  TOGGLE_SELECTED_VALIDATORS_GROUPS,
  REMOVE_SELECTED_RESPONSIBLES_MEMBERS,
  REMOVE_SELECTED_OBSERVERS_MEMBERS,
  REMOVE_SELECTED_VALIDATORS_MEMBERS, ADD_SELECTED_OBSERVERS_MEMBERS,
} from '@/store/modules/checklist/mutation_types'
export default {
  name: 'ChecklistShareTasksDialogRolePickerGroup',
  components: { ChecklistShareTasksDialogRolePickerGroupMember },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    taskVisibleByAll: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('checklist', ['shareTaskRolePickerSelectedResponsibles', 'shareTaskRolePickerSelectedObservers', 'shareTaskRolePickerSelectedValidators']),
    isObserversCheckboxDisabled () {
      return this.areResponsiblesChecked || this.areValidatorsChecked || this.group.isPm || this.taskVisibleByAll
    },
    areResponsiblesChecked () {
      return !!(
        this.shareTaskRolePickerSelectedResponsibles.groups.includes(this.group) ||
        (this.group.members.length > 0 && this.group.members.every(child => this.shareTaskRolePickerSelectedResponsibles.members.includes(child)))
      )
    },
    areObserversChecked () {
      return !!(
        this.shareTaskRolePickerSelectedObservers.groups.includes(this.group) ||
        (this.group.members.length > 0 && this.group.members.every(child => this.shareTaskRolePickerSelectedObservers.members.includes(child)))
      )
    },
    areValidatorsChecked () {
      return !!(
        this.shareTaskRolePickerSelectedValidators.groups.includes(this.group) ||
        (this.group.members.length > 0 && this.group.members.every(child => this.shareTaskRolePickerSelectedValidators.members.includes(child)))
      )
    },
  },
  methods: {
    onResponsiblesClick () {
      this.$store.commit(`checklist/${TOGGLE_SELECTED_RESPONSIBLES_GROUPS}`, this.group)
      this.group.members.forEach(member => {
        this.$store.commit(`checklist/${REMOVE_SELECTED_RESPONSIBLES_MEMBERS}`, member)
      })
      if (this.areResponsiblesChecked && !this.areObserversChecked) {
        this.onObserversClick()
      }
    },
    onObserversClick () {
      this.$store.commit(`checklist/${TOGGLE_SELECTED_OBSERVERS_GROUPS}`, this.group)
      this.group.members.forEach(member => {
        if (!this.shareTaskRolePickerSelectedResponsibles.members.includes(member)) {
          this.$store.commit(`checklist/${REMOVE_SELECTED_OBSERVERS_MEMBERS}`, member)
        } else if (this.shareTaskRolePickerSelectedResponsibles.members.includes(member)) {
          this.$store.commit(`checklist/${ADD_SELECTED_OBSERVERS_MEMBERS}`, member)
        }
      })
    },
    onValidatorsClick () {
      this.$store.commit(`checklist/${TOGGLE_SELECTED_VALIDATORS_GROUPS}`, this.group)
      this.group.members.forEach(member => {
        this.$store.commit(`checklist/${REMOVE_SELECTED_VALIDATORS_MEMBERS}`, member)
      })
      if (this.areValidatorsChecked && !this.areObserversChecked) {
        this.onObserversClick()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.ChecklistShareTasksDialogRolePickerGroup-row {
  display: grid;
  grid-template-columns: auto 180px 180px 180px;
  grid-gap: 10px;
  align-items: center;
  border: solid 1px #e0e0e0;
  background-color: rgba(75, 117, 181, 0.1);
}
</style>
